import React from "react";
import {useTranslation} from "react-i18next";
import {Select} from "antd";
//local
import {orderingNameValues} from "constants/select.consts";
import {changeSelectValue, changeFilterParams} from "helpers/helper";

const {Option} = Select;

const OurOffersTableHead = ({filters, onChangeOrder}) => {
  const {t} = useTranslation();

  const handleChangeOrder = (value) => onChangeOrder(changeFilterParams(value));
  const options = (values) =>
    values.map(({value, label}, i) => (
      <Option key={i} value={value}>
        {t(label)}
      </Option>
    ));

  return (
    <div className="requests-card_head">
      <div className="requests-card_head__name __wrapper">
        <div className="requests-card_head__name __select">
          <Select
            onChange={handleChangeOrder}
            value={changeSelectValue(orderingNameValues, filters)}
          >
            {options(orderingNameValues)}
          </Select>
        </div>
      </div>
      <div className="requests-card_head__project __wrapper">{t("PROJECT")}</div>
      <div className="requests-card_head__title __wrapper">{t("REQUEST")}</div>
      <div className="requests-card_head__column __wrapper">
        {t("OFFER_STATUS_SUBMITTED")}
      </div>
      <div className="requests-card_head__column __status">{t("BUYER_RESPONSE")}</div>
    </div>
  );
};

export default OurOffersTableHead;
